import React from 'react';
import { useApi } from '@backstage/core-plugin-api';
import { Entity } from '@backstage/catalog-model';
import { computeResourceDiscoveryApiRef } from '../../api';
import { AzureContextProvider } from './AzureContext';
import { Azure } from './Azure';
import { useEntity } from '@backstage/plugin-catalog-react';
import { CRDAzureConfig } from '@internal/backstage-plugin-compute-resource-discovery-new-common';
import { Alert } from '@mui/material';

type AzureWithProvidersProps = {
  projectCode: string;
  azureConfigs: CRDAzureConfig[] | undefined;
};

export const AzureWithProviders: React.FC<AzureWithProvidersProps> = ({
  projectCode,
  azureConfigs,
}) => {
  const { entity } = useEntity<Entity>();
  const api = useApi(computeResourceDiscoveryApiRef);

  if (!azureConfigs || azureConfigs.length === 0) {
    return (
      <Alert severity="warning" sx={{ my: 2 }}>
        Azure configuration not found for project code {projectCode}
      </Alert>
    );
  }

  return (
    <AzureContextProvider
      api={api}
      azureConfigs={azureConfigs}
      projectCode={projectCode}
    >
      <Azure entity={entity} />
    </AzureContextProvider>
  );
};
